<template>
  <vue-final-modal
    :value="store.sampleVisible"
    name="requestsample-dialog"
    :classes="['introduction-sample-dialog__container']"
    :content-class="[
      'introduction-sample-dialog',
      'introduction-sample-dialog__shell',
      'v--modal-box',
      'v--modal'
    ]"
    :click-to-close="true"
    :esc-to-close="true"
    :lock-scroll="true"
    attach="body"
    :z-index-base="10010"
    @input="store.setSampleVisible"
  >
    <div class="v--modal-close-top">
      <el-button
        @click="store.setSampleVisible(false)"
        icon="el-icon-close"
        type="text"
      />
    </div>
    <div class="title">例文を選ぶ</div>
    <div class="description">
      <p>選択した例文が追加されます。</p>
      <p class="attention">
        例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。
      </p>
    </div>
    <ul class="example-sentence">
      <li
        v-for="(item, idx) in store.requestSamples"
        :key="idx"
        @click="store.applySample(item.description)"
      >
        <div class="title">{{ item.title }}</div>
        <div class="body" v-html="item.description" />
      </li>
    </ul>
    <div class="text-right">
      <el-button @click="store.setSampleVisible(false)">閉じる</el-button>
    </div>
  </vue-final-modal>
</template>

<script setup lang="ts">
import { useIntroductionDialogStore } from '@/stores/introductionDialog'

const store = useIntroductionDialogStore()
</script>

<style lang="scss">
.introduction-sample-dialog__container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 16px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 10011;
}

.introduction-sample-dialog__shell.v--modal-box.v--modal {
  position: relative;
  box-sizing: border-box;
  flex: 0 0 auto;
  width: calc(100% - 32px);
  max-width: 600px;
  height: auto;
  max-height: 90vh;
  margin-block: auto;
  overflow-y: auto;
  border-radius: 8px;
  padding: 20px;
}
</style>
